import * as React from 'react';
import { Container, FormGroup, Label, Modal } from 'reactstrap';
import { Svg } from '../Svg';

interface IDeletedConfirmationModalProps {
  isOpen: boolean;
  toggleDeletedConfirmationModal: () => void;
}

export const DeletedConfirmationModal: React.SFC<
  IDeletedConfirmationModalProps
> = ({ isOpen, toggleDeletedConfirmationModal }) => {
  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleDeletedConfirmationModal}
        />
      </div>
      <Container className='p-5'>
        <FormGroup>
          <Label>Votre compte a été supprimé avec succès !</Label>
        </FormGroup>
      </Container>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Modals/DeletedConfirmationModal.tsx